import Vue from 'vue'
import VueRouter from 'vue-router'
import router from './router'
import App from './App.vue'
import ApiResource from '@/api'

import axios from 'axios'
import ElementUI from 'element-ui';             //全局引入element
import 'element-ui/lib/theme-chalk/index.css';    //全局引入element的样式

import vueJScroll from "@david-j/vue-j-scroll";


const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(ElementUI)
Vue.use(vueJScroll)
let currentLang = getItem('currentLang') || 'cn'
const EventBus = new Vue()
Vue.mixin({
  data() {
    return {
      currentLang: currentLang,// 默认中文
      isPC: window.innerWidth < 990 ? false : true
    }
  },
  beforeDestroy() {
    EventBus.$off('languageChanged', this.onLanguageChanged)
  },
  created() {
    EventBus.$on('languageChanged', this.onLanguageChanged)
  },
  methods: {
    changeLang(lang) {
      EventBus.$emit('languageChanged', lang)
    },
    onLanguageChanged(lang) {
      if (currentLang !== lang) {
        currentLang = lang
        setItem('currentLang', lang)
        this.currentLang = lang
      }
    }
  }
})

function setItem(item, value) {
  value = JSON.stringify(value)
  if (window.localStorage) {
    try {
      localStorage.setItem(item, value)
    } catch (e) {
      sessionStorage.setItem(item, value)
    }
  } else {
    sessionStorage.setItem(item, value)
  }
}

function getItem(item) {
  if (window.localStorage) {
    try {
      return JSON.parse(localStorage.getItem(item)) || null
    } catch (e) {
      return JSON.parse(sessionStorage.getItem(item)) || null
    }
  } else {
    return JSON.parse(sessionStorage.getItem(item)) || null
  }
}

let dataCn = getItem('_dataCn')
let dataEn = getItem('_dataEn')
let totalLike = getItem('_totalLike')
window.__systime = new Date()

function km_cl(idx) {
  this.idx = idx
  this.errorhandle = null
  this.cmdA = []
  this.cmdI = -1
  this.doCmdA = function (g) {
    if (g) { console.log(g) }
    if (this.cmdI == -1) { return 0 }
    if (this.cmdI == this.cmdA.length) {
      this.cmdA = []
      this.cmdI = -1
      return 1
    }
    let _n = this.cmdI
    this.cmdI++
    if (typeof this.cmdA[_n].func == 'function') {
      let _para = (typeof this.cmdA[_n].para == 'undefined') ? '' : this.cmdA[_n].para
      this.cmdA[_n].func(_para)
    }
  }
}

let cl = new km_cl('search')
cl.cmdA.push({
  func: function () {
    ApiResource('getDataCn').then((response) => {
      if (response.status === 200) {
        dataCn = response.data
        setItem('_dataCn', dataCn)
        window.__systime = new Date(response.headers.date)
      }
      cl.doCmdA()
    })
  }
})
cl.cmdA.push({
  func: function () {
    ApiResource('getDataEn').then((response) => {
      if (response.status === 200) {
        dataEn = response.data
        setItem('_dataEn', dataEn)
      }
      cl.doCmdA()
    })
  }
})

cl.cmdA.push({
  func: function () {
    axios.get('https://thumbsup-qbh-java-igdpvltehu.cn-shanghai.fcapp.run/show/refreshPraiseNew').then((response) => {
      if (response.data.status === 'success') {
        totalLike = response.data.data;
        setItem('_totalLike', totalLike)
      }
      cl.doCmdA()
    })
  }
})

cl.cmdA.push({
  func: function () {
    window.$('.start-loading').remove()
    Vue.prototype.$getItem = getItem
    Vue.prototype.$setItem = setItem

    Vue.prototype.$allData = {
      cn: dataCn,
      en: dataEn,
      totalLike: totalLike
    }
    new Vue({
      router,
      render: h => h(App),
    }).$mount('#app')
  }
})
cl.cmdI = 0
cl.doCmdA()

